import { TOrderCostError } from "../../../../../api/endpoints/Order";
import { useSelector } from "react-redux";
import { selectUser } from "../../../../../store/selectors/UserSelectors";
import OrderPolicy from "../../../../../policies/OrderPolicy";
import { Alert, Button } from "react-bootstrap";
import ExternalLink from "../../../../../components/Navigation/Links/ExternalLink";
import React, { Fragment, useState } from "react";
import { Collapse } from "react-collapse";

interface Props {
  error: TOrderCostError;
}

const FullErrorContent = (props: Props) => {
  const { error } = props;

  return (
    <Fragment>
      <p>
        {error.message}
      </p>
      <p>
        {error.traceback}
      </p>
    </Fragment>
  )
}

const ContactSupportContent = () => {
  return (
    <Fragment>
      An error occurred in the costing of your data. We are very sorry about this. Please
      contact Data Support via our&nbsp;
      <ExternalLink url="https://confluence.ecmwf.int/category/cd">support portal</ExternalLink>.
    </Fragment>
  )
}

const CostError = (props: { error: TOrderCostError }) => {
  const { error } = props;
  const user = useSelector(selectUser);
  const [detailsOpen, setDetailsOpen] = useState<boolean>(false);


  const content = OrderPolicy.canViewFullCostError(user) ?
    <FullErrorContent error={error} />
    : <ContactSupportContent />;

  return (
    <Alert variant="danger" className="cost-error">
      <Alert.Heading>Error</Alert.Heading>

      <div>
        <ContactSupportContent />
      </div>

      {
        OrderPolicy.canViewFullCostError(user) &&
        <div className="margin-top-sx">
          <div className="more-detail-link-wrapper">
            <Button
              className="more-details-link"
              variant="link"
              onClick={() => setDetailsOpen(!detailsOpen)}
            >
              See more details
            </Button>
          </div>

          <Collapse isOpened={detailsOpen}>
            <div className="margin-top-xs">
              <FullErrorContent error={error} />
            </div>
          </Collapse>
        </div>
      }
    </Alert>
  )
}

export default CostError;
